import React from 'react'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 14 14"
    >
      <path
        fill="#E11900"
        d="M10.333 3h3.334v1.333h-1.334V13a.667.667 0 01-.666.667H2.333A.666.666 0 011.667 13V4.333H.333V3h3.334V1a.667.667 0 01.666-.667h5.334a.667.667 0 01.666.667v2zM11 4.333H3v8h8v-8zm-6 2h1.333v4H5v-4zm2.667 0H9v4H7.667v-4zM5 1.667V3h4V1.667H5z"
      ></path>
    </svg>
  )
}

export default Icon
